import { render, staticRenderFns } from "./MyDonationList.vue?vue&type=template&id=6e352962&"
import script from "./MyDonationList.vue?vue&type=script&lang=js&"
export * from "./MyDonationList.vue?vue&type=script&lang=js&"
import style0 from "./MyDonationList.vue?vue&type=style&index=0&id=6e352962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports